const PRINT_QUEUE_KEY = 'beatq.merchant.printQueue.v1';

export type PrintQueueItem = {
  id: string;
  orderId: string;
  label: string;
  status: 'pending' | 'failed' | 'printed';
  updatedAt: string;
  retryCount?: number;
};

export type PrintHealth = 'online' | 'degraded' | 'offline';

export function loadPrintQueue(): PrintQueueItem[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(PRINT_QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as PrintQueueItem[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function savePrintQueue(items: PrintQueueItem[]): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(PRINT_QUEUE_KEY, JSON.stringify(items.slice(0, 40)));
}

export function upsertPrintQueueItem(item: PrintQueueItem): void {
  const rest = loadPrintQueue().filter((q) => q.id !== item.id && q.orderId !== item.orderId);
  savePrintQueue([item, ...rest]);
}

export function updatePrintQueueItem(id: string, patch: Partial<PrintQueueItem>): void {
  savePrintQueue(loadPrintQueue().map((item) => (item.id === id ? { ...item, ...patch } : item)));
}

export function pendingPrintCount(): number {
  return loadPrintQueue().filter((q) => q.status === 'pending' || q.status === 'failed').length;
}

export function printHealthFromQueue(items = loadPrintQueue()): PrintHealth {
  if (items.some((item) => item.status === 'failed')) return 'degraded';
  return 'online';
}

export function loadPrintHealth(): PrintHealth {
  return printHealthFromQueue();
}

export function savePrintHealth(_health: PrintHealth): void {
  /* Health is derived from the live print queue, not a demo toggle. */
}
